// DeleteConfirmDialog.tsx
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from "@mui/material";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
const DeleteConfirmDialog = ({
  open,
  onClose,
  onDelete,
  deleteFrom,
  deleteLoader,
}: {
  open: boolean;
  onClose: () => void;
  onDelete: () => void;
  deleteFrom: string;
  deleteLoader?: any;
}) => {
  return (
    <Dialog
      open={open}
      onClose={(_, reason) => {
        if (reason === "backdropClick") {
          return;
        }
        onClose();
      }}
      aria-labelledby="delete-confirm-dialog-title"
      maxWidth="xs"
      fullWidth
    >
      <DialogTitle sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <ErrorOutlineIcon color="secondary" />{" "}
        {deleteFrom === "comment"
          ? "Delete this comment?"
          : "Delete this file?"}
      </DialogTitle>
      <DialogContent>
        <Typography variant="body2">
          Once you delete, it's gone for good.
        </Typography>
      </DialogContent>
      <DialogActions sx={{ paddingBottom: "16px" }}>
        <Button onClick={onClose} color="secondary">
          Cancel
        </Button>
        <Button
          onClick={onDelete}
          color="secondary"
          variant="contained"
          loading={!!deleteLoader}
          loadingPosition="end" // keep "Delete" text visible
          sx={{ minWidth: 120 }}
        >
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteConfirmDialog;
